import { type JSX, h } from "@stencil/core";
import { getVehiclePurchaseRoutingKey } from "@phn/entities/routing-key";
import type { TLink } from "@phn/entities/content";
import { EventActions } from "@phn/utility/constants";
import MenuItemCountIndicator from "./menu-item-count-indicator";

export default function MenuItemLink({
  content,
  count,
}: {
  content: TLink | null;
  count: number;
}): JSX.Element | null {
  return content ? (
    <phn-nd-menu-item
      elementId={getVehiclePurchaseRoutingKey(content.id)}
      key={content.id}
      class="vehiclepurchase-link"
      analyticsId={content.id}
      text={content.text}
      link={content.link}
      datalayerEventAction={EventActions.NAVIGATION_LINK_CLICK}
      role="listitem"
    >
      <MenuItemCountIndicator count={count} />
    </phn-nd-menu-item>
  ) : null;
}
